module.exports = __webpack_public_path__ + "img/btn-left.9fa99023.png";